(($, win) => {
    "use strict";

    $.enhancer("localCoursedatesFilter",
        {
            searchWrapper: null,
            monthSelect: null,
            lengthSelect: null,
            noHitsMessage: null,
            
            init: function (el) {

                this.searchWrapper = $(el);
                this.monthSelect = $("#month-select");
                this.lengthSelect = $("#length-select");
                this.noHitsMessage = $("#no-hits-message");

                var queryParams = $.queryString.parse(win.location.search);

                if (queryParams["month"] && this.monthSelect.find("option[value=\"" + queryParams["month"] + "\"]").length) {
                    this.monthSelect.val(queryParams["month"]);
                }

                if (queryParams["lenght"] && this.lengthSelect.find("option[value=\"" + queryParams["length"] + "\"]").length) {
                    this.lengthSelect.val(queryParams["lenght"]);
                }

                if (queryParams["month"] || queryParams["lenght"]) {
                    this.filterList();
                }

                this.monthSelect.on("change", this.handleFilterChange.bind(this));
                this.lengthSelect.on("change", this.handleFilterChange.bind(this));

            },
            
            handleFilterChange: function (e) {

                this.filterList();

                this.updateLocation();

            },

            filterList: function () {
                var enhancer = this;

                this.searchWrapper.find("li.date-item").each(function () {
                    var matchesFilter = enhancer.checkSelectConditions(this);
                    $(this).toggleClass("hidden", !matchesFilter);
                });

                var hasResults = this.searchWrapper.find("li.date-item:not(.hidden)").length > 0;

                this.noHitsMessage.toggleClass("hidden", hasResults);
            },

            checkSelectConditions: function (el) {

                return (this.monthSelect.val() == "" || this.monthSelect.val() == el.dataset.month)
                    &&
                    (this.lengthSelect.val() == "" || String(this.lengthSelect.val()) == String(el.dataset.length));

            },

            updateLocation: function () {
                var queryParams = $.queryString.parse(win.location.search);

                queryParams["month"] = this.monthSelect.val();
                queryParams["length"] = this.lengthSelect.val();

                win.history.replaceState(null, null, win.location.pathname + $.queryString.build(queryParams));
            }
            
        });

})(jQuery, window);
